import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import StarOutlineRoundedIcon from '@mui/icons-material/StarOutlineRounded';
import Filter5OutlinedIcon from '@mui/icons-material/Filter5Outlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import CakeOutlinedIcon from '@mui/icons-material/CakeOutlined';

/**
 * Customer lists reachable from the Contatti tab (see MOBILE_PLAN.md §F(3)).
 * Single source of section icons shared by the ListSheet and the ContactCard
 * avatars — outlined variants of the desktop ROUTE_ICONS.
 *
 * Named by route key only: where each list is served, and whether the user
 * holds it, comes from the server's route tree (see useMobileNavigation).
 */
export const MOBILE_LISTS = [
  {
    key: 'CUSTOMERS',
    labelKey: 'ALL_CUSTOMERS',
    Icon: PeopleAltOutlinedIcon,
  },
  {
    key: 'LIGHT',
    labelKey: 'LIGHT',
    Icon: StarOutlineRoundedIcon,
  },
  {
    key: 'CORPORATE',
    labelKey: 'CORPORATE',
    Icon: Filter5OutlinedIcon,
  },
  {
    key: 'PREMIUMBANK',
    labelKey: 'PREMIUMBANK',
    Icon: AccountBalanceOutlinedIcon,
  },
  {
    key: 'BIRTHDAYS',
    labelKey: 'BIRTHDAYS',
    Icon: CakeOutlinedIcon,
  },
];
